import {Routes} from '@angular/router';
import {authGuard} from "./core";
import {AuthLayoutComponent} from "./theme/auth-layout/auth-layout.component";
import {AdminLayoutComponent} from "./theme/admin-layout/admin-layout.component";
import {LoginComponent} from "./pages/sessions/login/login.component";
import {RegisterComponent} from "./pages/sessions/register/register.component";
import {Error403Component} from "./pages/sessions/403.component";
import {Error404Component} from "./pages/sessions/404.component";
import {Error500Component} from "./pages/sessions/500.component";
import {DashboardComponent} from "./routes/dashboard/dashboard.component";
import {MainLayoutComponent} from "./theme/main-layout/main-layout.component";
import {SearchComponent} from "./pages/main/search/search.component";
import {
  ProductSearchHistoryComponent
} from "./pages/admin/product/product-search-history/product-search-history.component";

export const routes: Routes = [
  {path: '', redirectTo: 'search', pathMatch: 'full'},
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'search',
        component: SearchComponent,
      },
      {
        path: 'catalog',
        loadChildren: () => import('./pages/main/main.routes').then(m => m.routes),
      },
    ]
  },

  {
    path: 'admin',
    component: MainLayoutComponent,
    children: [
      {
        path: 'main',
        loadChildren: () => import('./pages/admin/main/main.routes').then(m => m.routes),
      },
      {
        path: 'category',
        loadChildren: () => import('./pages/admin/category/category.routes').then(m => m.routes),
      },
      {
        path: 'product',
        loadChildren: () => import('./pages/admin/product/product.routes').then(m => m.routes),
      },
      {
        path: 'operation',
        loadChildren: () => import('./pages/admin/operation/operation.routes').then(m => m.routes),
      },
      {
        path: 'user',
        loadChildren: () => import('./pages/admin/user/user.routes').then(m => m.routes),
      },
      {
        path: 'statistics',
        loadChildren: () => import('./pages/admin/statistics/statistics.routes').then(m => m.routes),
      },
      {
        path: 'repairs',
        loadChildren: () => import('./pages/admin/repair/repair.routes').then(m => m.routes),
      },
      {path: 'search/history', component: ProductSearchHistoryComponent},
    ]
  },

  // {
  //   path: '',
  //   component: AdminLayoutComponent,
  //   canActivate: [authGuard],
  //   canActivateChild: [authGuard],
  //   children: [
  //     // {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
  //     {path: 'dashboard', component: DashboardComponent},
  //     {path: '403', component: Error403Component},
  //     {path: '404', component: Error404Component},
  //     {path: '500', component: Error500Component},
  //     {
  //       path: 'design',
  //       loadChildren: () => import('./routes/design/design.routes').then(m => m.routes),
  //     },
  //     {
  //       path: 'material',
  //       loadChildren: () => import('./routes/material/material.routes').then(m => m.routes),
  //     },
  //     {
  //       path: 'media',
  //       loadChildren: () => import('./routes/media/media.routes').then(m => m.routes),
  //     },
  //     {
  //       path: 'forms',
  //       loadChildren: () => import('./routes/forms/forms.routes').then(m => m.routes),
  //     },
  //     {
  //       path: 'tables',
  //       loadChildren: () => import('./routes/tables/tables.routes').then(m => m.routes),
  //     },
  //     {
  //       path: 'profile',
  //       loadChildren: () => import('./routes/profile/profile.routes').then(m => m.routes),
  //     },
  //     {
  //       path: 'permissions',
  //       loadChildren: () => import('./routes/permissions/permissions.routes').then(m => m.routes),
  //     },
  //     {
  //       path: 'utilities',
  //       loadChildren: () => import('./routes/utilities/utilities.routes').then(m => m.routes),
  //     },
  //   ],
  // },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {path: 'login', component: LoginComponent},
      {path: 'register', component: RegisterComponent},
    ],
  },
  {path: '403', component: Error403Component},
  {path: '**', component: Error404Component},


];
